import { array, literal, object, string, tuple, enum as zodEnum } from 'zod';

export const FuelGradesConfigurationSchema = object({
  /**
   * Order in mapping array determines sorting order
   */
  mapping: array(tuple([string(), array(string()).min(1)])),
  default: string(),
  sortPrices: zodEnum(['AsDefined', 'Asc']).default('AsDefined'),
});

export const AppStoreURLsConfigurationSchema = object({
  ios: string().url().nullable(),
  android: string().url().nullable(),
});

export const LocalRetailerConfigurationSchema = object({
  version: literal(3),
  universalLinkOrigins: array(string().url()).min(1),
  fuelGrades: FuelGradesConfigurationSchema,
  appStoreURLs: AppStoreURLsConfigurationSchema,
}).strict();
